import { withLayout } from '../../Layout/Layout';
import { DestinationList } from '../../components'

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};
export const getStaticProps = async ({ params }) => {
  const country = params.country;
  return {
    props: {
      country
    },
    revalidate: 60 * 60 * 2,
  };
};


function CountryDestinations({country}) {
  return (
    <DestinationList country={country}/>
  );
}

export default withLayout(CountryDestinations, false);
